<template>
  <ValidationObserver
    v-slot="{handleSubmit, invalid}"
    ref="form"
  >
    <b-modal
      id="moduleModal"
      v-model="modal.show"
      :title="getCurrentTitle"
      @hidden="onHidden"
      @hide="beforeHide"
    >
      <b-alert
        :show="!!errorMessage"
        variant="danger"
        dismissible
        data-title="error-message"
      >
        {{ errorMessage }}
      </b-alert>
      <content-spinner
        :show="loading"
        text="Please wait..."
      />
      <b-form
        :class="{ hide: loading }"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset="handleSubmit(onReset)"
      >
        <input-widget
          id="createModuleName"
          :model="form"
          :field="fields.moduleName"
          :autofocus="true"
        />
        <input-widget
          :field="fields.description"
          :model="form"
        />
        <vfa-picker
          v-model="form.icon"
          :only="onlyIcons"
          class="icon-select-input"
        >
          <template #activator="{ on }">
            <b-button
              id="selectModuleIconBtn"
              variant="warning"
              @click="on"
            >
              Choose Icon
            </b-button>
            <font-awesome-icon
              v-if="form.icon"
              id="selectModuleIcon"
              class="selected-icon"
              :icon="['fas', form.icon]"
            />
          </template>
        </vfa-picker>
      </b-form>
      <div
        slot="modal-footer"
        class="d-flex"
      >
        <b-button
          id="moduleModalCancel"
          class="mt-3 mr-3"
          block
          @click="$bvModal.hide('moduleModal')"
        >
          Cancel
        </b-button>
        <b-button
          id="moduleModalOk"
          class="mt-3"
          variant="primary"
          :disabled="invalid"
          block
          @click.prevent="handleSubmit(onSubmit);"
        >
          OK
        </b-button>
      </div>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../../core/components/ContentSpinner';
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import {v4 as uuidv4} from 'uuid';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');
const {mapActions: sidebarActions} = createNamespacedHelpers('sidebar');
export default {
  name: 'ModuleModal',
  components: {InputWidget, ContentSpinner},
  data() {
    return {
      errorMessage: null,
      form: {
        label: '',
        description: '',
        icon: '',
      },
      fields: {
        moduleName: {
          type: 'text',
          required: true,
          label: 'Name',
          name: 'label',
          max: 45,
        },
        description: {
          type: 'textarea',
          required: false,
          label: 'Description',
          name: 'description',
        },
      },
    };
  },
  watch: {
    moduleData: {
      handler(val) {
        this.form = val || this.form;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(['onlyIcons']),
    ...mapState({
      modal: state => state.moduleModal,
      moduleData: state => state.moduleModal.data,
      loading: state => state.moduleModal.loading,
      permissionTypes: state => state.permissionTypes,
    }),
    getCurrentTitle() {
      return this.moduleData && this.moduleData.moduleGuid
        ? `Update Module "${this.moduleData.label}"`
        : 'Create Module';
    },
  },
  methods: {
    ...mapActions([
      'hideModuleModal',
      'createModule',
      'updateModule',
      'restoreModule',
    ]),
    ...sidebarActions(['getSidebarStructure']),
    async onSubmit() {
      const requestBody = {
        ...this.form,
        moduleName: this.form.label,
        moduleIcon: this.form.icon,
      };

      if (this.form.moduleGuid) {

        const response = await this.updateModule(requestBody);
        this.errorMessage = response.body.message;
        if (response.success) {
          this.$toasted.success(`Module "${this.form.label}" was updated`, {
            duration: TOASTER_DURATION,
          });
          this.hideModuleModal();
        } else if (response.body.isDeleted) {
          await this.showRestoreModuleModal(this.form.label, response.body.uuid);
        } else {
          this.$toasted.error(response.body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      } else {
        requestBody.moduleGuid = uuidv4();
        requestBody.currentUserPermissionLevel = this.permissionTypes.admin;
        const response = await this.createModule(requestBody);
        this.errorMessage = response.body.ErrorMessage;
        if (response.success) {
          this.$toasted.success(`Module "${this.form.label}" was created`, {
            duration: TOASTER_DURATION,
          });
          this.hideModuleModal();
          // this.hideModuleModal()
        } else if (response.body.isDeleted) {
          await this.showRestoreModuleModal(this.form.label, response.body.uuid);
        } else {
          this.$toasted.error(response.body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
      await this.updateModulesInfo();
    },
    async showRestoreModuleModal(moduleName, moduleUuid) {
      const success = await this.$confirm(
        'Restore Module...',
        `Module with the name '${moduleName}' already exists in the 'Recycle Bin' would you like to restore?`,
        null,
        null,
        null,
        [{
          title: 'Recycle Bin',
          variant: 'success',
          callback: (hideModal) => {
            if (hideModal) {
              hideModal();
            }
            this.hideModuleModal();
            this.$router.push({name: 'recycleBin', query: {search: moduleName}});
          },
        }],
      );

      if (success) {
        const restoreModule = await this.restoreModule({id: moduleUuid, restrictFetch: true});
        if (restoreModule.success) {
          this.hideModuleModal();
        }
      }
    },
    beforeHide(e) {
      this.errorMessage = '';
      if (this.loading) {
        e.preventDefault();
        return false;
      }
    },
    onHidden() {
      this.form = {};
      this.hideModuleModal();
    },
    async updateModulesInfo() {
      await this.getSidebarStructure();
    },
  },
};
</script>

<style scoped>
.icon-select-input {
  display: flex;
  align-items: center;
  gap: 10px;


  & .selected-icon {
    width: 20px;
    height: 20px;
    padding: 5px;
    border: 1px solid #ced4da;
  }
}

.hide {
  display: none;
}
</style>